import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export function trackSwipeMoveToArchiveClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'archive',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeMarkAsReadClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'read',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeDeleteClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'delete',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeUnblockClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'unblock',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeRemoveFromArchiveClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'restore',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
